import {APP_NAME} from '../Config/constants.js';
import {Typography} from '@mui/material';

function Copyright (props) {
    if (props.login || props.desktop) { 
        return (
        <Typography variant="body2">
            Version {props.beConfigs?.version} - &copy; {new Date().getFullYear()} {APP_NAME} - All rights reserved
        </Typography>
        )
    }
    else {
        return (
            <>
                <Typography variant="body2">
                    Version XXXX
                </Typography>    
                <Typography variant="body2">
                    &copy; {new Date().getFullYear()} {APP_NAME} - All rights reserved
                </Typography>  
            </>
        )
    }
}

export default Copyright;
